import { gql } from "@apollo/client";

export const LIST_COMPANY_PAYMENT_DEADLINES = gql`
  query listCompanyPaymentDeadlines(
    $filter: CompanyPaymentDeadlineFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listCompanyPaymentDeadlines(filter: $filter) {
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        key: id
        id
        name
        description
        beginningDay
        numberOfDays
        payDay
        canBeDeleted
        canBeArchived
        archivedBy
        archivedAt
        editable
      }
      totalCount
    }
  }
`;

export const GET_COMPANY_PAYMENT_DEADLINE = gql`
  query getCompanyPaymentDeadline($id: ID!) {
    getCompanyPaymentDeadline(id: $id) {
      id
      name
      description
      beginningDay
      numberOfDays
      payDay
    }
  }
`;

export const CREATE_COMPANY_PAYMENT_DEADLINE = gql`
  mutation createCompanyPaymentDeadline($input: CompanyPaymentDeadlineCreateInput!) {
    createCompanyPaymentDeadline(input: $input) {
      success
      errors {
        messages
        field
      }
      companyPaymentDeadline {
        id
        name
        description
        beginningDay
        numberOfDays
        payDay
      }
    }
  }
`;

export const UPDATE_COMPANY_PAYMENT_DEADLINE = gql`
  mutation updateCompanyPaymentDeadline($input: CompanyPaymentDeadlineUpdateInput!) {
    updateCompanyPaymentDeadline(input: $input) {
      success
      errors {
        messages
        field
      }
      companyPaymentDeadline {
        id
        name
        description
        beginningDay
        numberOfDays
        payDay
      }
    }
  }
`;

export const DELETE_COMPANY_PAYMENT_DEADLINE = gql`
  mutation deleteCompanyPaymentDeadline($id: ID!) {
    deleteCompanyPaymentDeadline(id: $id) {
      success
      errors {
        messages
        field
      }
    }
  }
`;

export const UPDATE_ACCOUNTANT_TRANSFER = gql`
  mutation updateAccountantTransferDefaults($input: AccountantTransferDefaultsInputUpdate!) {
    updateAccountantTransferDefaults(input: $input) {
      success
      errors {
        messages
        field
      }
    }
  }
`;

export const LIST_EXPORT_FORMATS_ENUM_OPTIONS = gql`
  query {
    listExportFormats: listExportFormats {
      label
      value
    }
  }
`;

export const GET_ACCOUNTANT_TRANSFER_DEFAULTS = gql`
  query getAccountantTransferDefaults($company: ID!) {
    getAccountantTransferDefaults(companyId: $company) {
      id
      companyId
      sellBookCode
      sellBookData {
        id
        name
        code
      }
      clientCounterpartData {
        code
        id
        name
      }
      advancePaymentIssuedCounterpart
      advancePaymentIssuedCounterpartData {
        code
        id
        name
      }
      advancePaymentReceivedCounterpart
      advancePaymentReceivedCounterpartData {
        code
        id
        name
      }
      advancePaymentIssuedTvaCounterpart
      advancePaymentIssuedTvaCounterpartData {
        id
        name
        code
      }
      advancePaymentReceivedTvaCounterpart
      advancePaymentReceivedTvaCounterpartData {
        id
        name
        code
      }
    }
  }
`;

export const GET_COMPANY_EMAIL_TEMPLATE = gql`
  query getCompanyEmailTemplate($companyId: ID!, $documentId: ID, $paymentId: ID) {
    getCompanyEmailTemplate(companyId: $companyId, documentId: $documentId, paymentId: $paymentId) {
      title
      content
      titleReminder3
      titleReminder2
      titleReminder1
      titleOrderReminder
      titleReminderGroupedDocuments
      contentReminder3
      contentReminder2
      contentReminder1
      contentReminderGroupedDocuments
      contentOrderReminder
      contentBudget
      contentSaleOrder
      titleBudget
      titleSaleOrder
      contentThankYouForPayment
      titleThankYouForPayment
    }
  }
`;

export const LIST_EMAIL_EXTRA_FILES = gql`
  query listEmailExtraFiles($filter: EmailExtraFileFilter!, $offset: Int, $limit: Int) {
    listEmailExtraFiles(filter: $filter) {
      results(offset: $offset, limit: $limit, orderBy: "id") {
        id
        fileUrl
        label
        isActiveBudget
        isActiveSaleOrder
        isActiveDeliveryForm
        isActivePurchaseOrder
        isActiveReturn
        isActiveReceipt
        isActivePaymentInAdvance
      }
      totalCount
    }
  }
`;

export const GET_EMAIL_EXTRA_FILES = gql`
  query getEmailExtraFiles($id: ID!) {
    getEmailExtraFiles(id: $id) {
      fileUrl
      label
      isActiveBudget
      isActiveSaleOrder
      isActiveDeliveryForm
      isActivePurchaseOrder
      isActiveReturn
      isActiveReceipt
      isActivePaymentInAdvance
    }
  }
`;

export const CREATE_EMAIL_EXTRA_FILE = gql`
  mutation createEmailExtraFile($input: EmailExtraFilesInput!) {
    createEmailExtraFile(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_EMAIL_EXTRA_FILE = gql`
  mutation updateEmailExtraFile($input: EmailExtraFilesUpdateInput!) {
    updateEmailExtraFile(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const DELETE_EMAIL_EXTRA_FILE = gql`
  mutation deleteEmailExtraFile($id: ID!) {
    deleteEmailExtraFile(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const UPDATE_COMPANY_EMAIL_TEMPLATE = gql`
  mutation updateCompanyEmailTemplate($input: CompanyEmailTemplateInput!) {
    updateCompanyEmailTemplate(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const DELETE_SALE_DOCUMENT_TEMPLATE = gql`
  mutation deleteSaleDocumentTemplate($id: ID!) {
    deleteSaleDocumentTemplate(id: $id) {
      success
      errors {
        messages
        field
      }
    }
  }
`;

export const CREATE_SALE_DOCUMENT_TEMPLATE = gql`
  mutation createSaleDocumentTemplate($input: CreateSaleDocumentTemplateInput!) {
    createSaleDocumentTemplate(input: $input) {
      saleDocumentTemplate {
        id
      }
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const UPDATE_SALE_DOCUMENT_TEMPLATE = gql`
  mutation updateSaleDocumentTemplate($input: UpdateSaleDocumentTemplateInput!) {
    updateSaleDocumentTemplate(input: $input) {
      saleDocumentTemplate {
        id
      }
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const IMPORT_PRODUCTS_FROM_FILE = gql`
  mutation importProductsFromFile($input: ImportProductsInput!) {
    importProductsFromFile(input: $input) {
      errors {
        field
        messages
      }
      success
      errorsPerCode {
        code
        errors {
          field
          messages
          type {
            label
            value
          }
        }
      }
    }
  }
`;

export const IMPORT_CATEGORIES_FROM_FILE = gql`
  mutation importCategoriesFromFile($input: ImportCategoriesInput!) {
    importCategoriesFromFile(input: $input) {
      errors {
        field
        messages
      }
      success
      total
      totalNew
    }
  }
`;

export const IMPORT_CLIENT_INFO = gql`
  mutation importClientInfo($input: ImportClientConfigsInput!) {
    importClientInfo(input: $input) {
      success
      errors {
        messages
        field
      }
      errorsPerCode {
        code
        errors {
          field
          messages
          type {
            label
            value
          }
        }
      }
      total
      totalNew
    }
  }
`;

export const COMPANY_FINISHED_SETUP = gql`
  mutation companyFinishedSetup($companyId: ID!) {
    companyFinishedSetup(companyId: $companyId) {
      success
      errors {
        messages
        field
      }
    }
  }
`;

export const READY_FOR_EXPORT_NEOFACT = gql`
  query readyForExport($companyId: ID!) {
    readyForExport(companyId: $companyId) {
      totalDocuments
    }
  }
`;
